import React from "react";
import "./SideBar.css";
import Data from "./SideBarData";
import { Link } from "react-router-dom";

function SideBar({ isTechTeam }) {
  return (
    <>
      <div className="sidebar">
        <div className="sidebar-items">
          {Data.map((item, index) => {
            if (
              isTechTeam ||
              (!isTechTeam && item.title !== "Knowledge Base")
            ) {
              return (
                <li key={index} className={item.cName}>
                  <Link to={item.path}>{item.title}</Link>
                </li>
              );
            }
          })}
        </div>
      </div>
    </>
  );
}

export default SideBar;
